// @flow

// export const RECKONING_ILLICIT_REAPER_WARLOCK = [
//   2030998601, // Illicit Reaper Hood
//   3734494144, // Illicit Reaper Gloves
//   2966502280, // Illicit Reaper Robes
//   2429433850, // Illicit Reaper Boots
//   373632485 // Illicit Reaper Bond
// ];
//
// export const RECKONING_ILLICIT_INVADER_WARLOCK = [
//   2342017355, // Illicit Invader Hood
//   239713978, // Illicit Invader Gloves
//   1258016014, // Illicit Invader Robes
//   1920643316, // Illicit Invader Boots
//   1576110551 // Illicit Invader Bond
// ];
//
// export const RECKONING_ILLICIT_ILLICIT_WARLOCK = [
//   359531057, // Illicit Collector Hood
//   3271153032, // Illicit Collector Gloves
//   4174424192, // Illicit Collector Robes
//   77525090, // Illicit Collector Boots
//   3526140221 // Illicit Collector Bond
// ];
//
// export const RECKONING_ILLICIT_SENTRY_WARLOCK = [
//   1823966645, // Illicit Sentry Hood
//   458336260, // Illicit Sentry Gloves
//   2765681916, // Illicit Sentry Robes
//   2005998382, // Illicit Sentry Boots
//   4051618673 // Illicit Sentry Bond
// ];

export const RECKONING_ILLICIT_SENTRY_HUNTER = [
  1000646860, // Illicit Sentry Mask
  154944645, // Illicit Sentry Grips
  2655279451, // Illicit Sentry Vest
  77816839, // Illicit Sentry Strides
  1394979698 // Illicit Sentry Cloak
];

export const RECKONING_ILLICIT_COLLECTOR_HUNTER = [
  1654117930, // Illicit Collector Mask
  1659679091, // Illicit Collector Grips
  2447741853, // Illicit Collector Vest
  1394633029, // Illicit Collector Strides
  3909729744 // Illicit Collector Cloak
];

export const RECKONING_ILLICIT_REAPER_HUNTER = [
  4144123204, // Illicit Reaper Mask
  4091317789, // Illicit Reaper Grips
  3971188131, // Illicit Reaper Vest
  1737518783, // Illicit Reaper Strides
  3252994970 // Illicit Reaper Cloak
];

export const RECKONING_ILLICIT_INVADER_HUNTER = [
  3146160048, // Illicit Invader Mask
  2943943681, // Illicit Invader Grips
  3597838551, // Illicit Invader Vest
  143821939, // Illicit Invader Strides
  1431190694 // Illicit Invader Cloak
];

export const RECKONING_ILLICIT_INVADER_TITAN = [
  1854337492, // Illicit Invader Helm
  685165933, // Illicit Invader Gauntlets
  2731689491, // Illicit Invader Plate
  931507503, // Illicit Invader Greaves
  1066605642 // Illicit Invader Mark
];

export const RECKONING_ILLICIT_SENTRY_TITAN = [
  1630402260, // Illicit Sentry Helm
  2320491441, // Illicit Sentry Gauntlets
  3423777255, // Illicit Sentry Plate
  2151744259, // Illicit Sentry Greaves
  4139274998 // Illicit Sentry Mark
];

export const RECKONING_ILLICIT_REAPER_TITAN = [
  1909470440, // Illicit Reaper Helm
  1256804729, // Illicit Reaper Gauntlets
  1148781279, // Illicit Reaper Plate
  4148887147, // Illicit Reaper Greaves
  2395939950 // Illicit Reaper Mark
];

export const RECKONING_ILLICIT_COLLECTOR_TITAN = [
  1266712686, // Illicit Collector Helm
  2716373471, // Illicit Collector Gauntlets
  274659609, // Illicit Collector Plate
  1637623713, // Illicit Collector Greaves
  1630402260 // Illicit Collector Mark
];

export const RECKONING_OUTLAWED_INVADER_TITAN = [
  200738237, // Outlawed Invader Helm
  1555512372, // Outlawed Invader Gauntlets
  386784170, // Outlawed Invader Plate
  3131634454, // Outlawed Invader Greaves
  3038467651 // Outlawed Invader Mark
];

export const RECKONING_OUTLAWED_SENTRY_TITAN = [
  1698832197, // Outlawed Sentry Helm
  1646026780, // Outlawed Sentry Gauntlets
  2066422690, // Outlawed Sentry Plate
  3587195070, // Outlawed Sentry Greaves
  1348229531 // Outlawed Sentry Mark
];

export const RECKONING_OUTLAWED_REAPER_TITAN = [
  360521697, // Outlawed Reaper Helm
  2263035824, // Outlawed Reaper Gauntlets
  1744000486, // Outlawed Reaper Plate
  2094288642, // Outlawed Reaper Greaves
  2459498231 // Outlawed Reaper Mark
];

export const RECKONING_OUTLAWED_COLLECTOR_TITAN = [
  2525623543, // Outlawed Collector Helm
  3729613894, // Outlawed Collector Gauntlets
  4120018288, // Outlawed Collector Plate
  2482419592, // Outlawed Collector Greaves
  1978904077 // Outlawed Collector Mark
];

export const RECKONING_NOTORIOUS_INVADER_TITAN = [
  200738238, // Notorious Invader Helm
  1555512375, // Notorious Invader Gauntlets
  386784169, // Notorious Invader Plate
  3131634453, // Notorious Invader Greaves
  3038467648 // Notorious Invader Mark
];

export const RECKONING_NOTORIOUS_SENTRY_TITAN = [
  1698832198, // Notorious Sentry Helm
  1646026783, // Notorious Sentry Gauntlets
  2066422689, // Notorious Sentry Plate
  3587195069, // Notorious Sentry Greaves
  1348229528 // Notorious Sentry Mark
];

export const RECKONING_NOTORIOUS_REAPER_TITAN = [
  360521698, // Notorious Reaper Helm
  2263035827, // Notorious Reaper Gauntlets
  1744000485, // Notorious Reaper Plate
  2094288641, // Notorious Reaper Greaves
  2459498228 // Notorious Reaper Mark
];

export const RECKONING_NOTORIOUS_COLLECTOR_TITAN = [
  2525623540, // Notorious Collector Helm
  3729613893, // Notorious Collector Gauntlets
  4120018291, // Notorious Collector Plate
  2482419595, // Notorious Collector Greaves
  1978904078 // Notorious Collector Mark
];

export const RECKONING_OUTLAWED_INVADER_HUNTER = [
  493448177, // Outlawed Invader Mask
  249655104, // Outlawed Invader Grips
  4053228822, // Outlawed Invader Vest
  1320043186, // Outlawed Invader Strides
  1886580967 // Outlawed Invader Cloak
];

export const RECKONING_OUTLAWED_COLLECTOR_HUNTER = [
  1722308939, // Outlawed Collector Mask
  1769446802, // Outlawed Collector Grips
  2082319036, // Outlawed Collector Vest
  1504400868, // Outlawed Collector Strides
  3585883633 // Outlawed Collector Cloak
];

export const RECKONING_OUTLAWED_REAPER_HUNTER = [
  3639906117, // Outlawed Reaper Mask
  3587100700, // Outlawed Reaper Grips
  2635164578, // Outlawed Reaper Vest
  1233301694, // Outlawed Reaper Strides
  1916971419 // Outlawed Reaper Cloak
];

export const RECKONING_OUTLAWED_SENTRY_HUNTER = [
  3280699113, // Outlawed Sentry Mask
  2628033400, // Outlawed Sentry Grips
  3998122206, // Outlawed Sentry Vest
  1225148522, // Outlawed Sentry Strides
  950313583 // Outlawed Sentry Cloak
];

export const RECKONING_NOTORIOUS_INVADER_HUNTER = [
  493448178, // Notorious Invader Mask
  249655107, // Notorious Invader Grips
  4053228821, // Notorious Invader Vest
  1320043185, // Notorious Invader Strides
  1886580964 // Notorious Invader Cloak
];

export const RECKONING_NOTORIOUS_COLLECTOR_HUNTER = [
  1722308936, // Notorious Collector Mask
  1769446801, // Notorious Collector Grips
  2082319039, // Notorious Collector Vest
  1504400871, // Notorious Collector Strides
  3585883634 // Notorious Collector Cloak
];

export const RECKONING_NOTORIOUS_REAPER_HUNTER = [
  3639906118, // Notorious Reaper Mask
  3587100703, // Notorious Reaper Grips
  2635164577, // Notorious Reaper Vest
  1233301693, // Notorious Reaper Strides
  1916971416 // Notorious Reaper Cloak
];

export const RECKONING_NOTORIOUS_SENTRY_HUNTER = [
  3280699114, // Notorious Sentry Mask
  2628033403, // Notorious Sentry Grips
  3998122205, // Notorious Sentry Vest
  1225148521, // Notorious Sentry Strides
  950313580 // Notorious Sentry Cloak
];

export const RECKONING_OUTLAWED_REAPER_WARLOCK = [
  2030998600, // Outlawed Reaper Hood
  3734494145, // Outlawed Reaper Gloves
  2966502281, // Outlawed Reaper Robes
  2429433851, // Outlawed Reaper Boots
  373632484 // Outlawed Reaper Bond
];

export const RECKONING_OUTLAWED_INVADER_WARLOCK = [
  2342017354, // Outlawed Invader Hood
  239713979, // Outlawed Invader Gloves
  1258016015, // Outlawed Invader Robes
  1920643317, // Outlawed Invader Boots
  1576110550 // Outlawed Invader Bond
];

export const RECKONING_OUTLAWED_COLLECTOR_WARLOCK = [
  359531056, // Outlawed Collector Hood
  3271153033, // Outlawed Collector Gloves
  4174424193, // Outlawed Collector Robes
  77525091, // Outlawed Collector Boots
  3526140220 // Outlawed Collector Bond
];

export const RECKONING_OUTLAWED_SENTRY_WARLOCK = [
  1823966644, // Outlawed Sentry Hood
  458336261, // Outlawed Sentry Gloves
  2765681917, // Outlawed Sentry Robes
  2005998383, // Outlawed Sentry Boots
  4051618672 // Outlawed Sentry Bond
];

export const RECKONING_ILLICIT_REAPER_WARLOCK = [
  2013313923, // Illicit Reaper Hood
  3150852690, // Illicit Reaper Gloves
  1852587798, // Illicit Reaper Robes
  3552091116, // Illicit Reaper Boots
  1182214975 // Illicit Reaper Bond
];

export const RECKONING_ILLICIT_INVADER_WARLOCK = [
  3731378629, // Illicit Invader Hood
  175511444, // Illicit Invader Gloves
  727872428, // Illicit Invader Robes
  38792606, // Illicit Invader Boots
  3426527713 // Illicit Invader Bond
];

export const RECKONING_ILLICIT_SENTRY_WARLOCK = [
  1262430251, // Illicit Sentry Hood
  3838077978, // Illicit Sentry Gloves
  844443758, // Illicit Sentry Robes
  1265513556, // Illicit Sentry Boots
  1586892599 // Illicit Sentry Bond
];

export const RECKONING_ILLICIT_COLLECTOR_WARLOCK = [
  3638406027, // Illicit Collector Hood
  1960663290, // Illicit Collector Gloves
  2195587150, // Illicit Collector Robes
  3641592628, // Illicit Collector Boots
  2938035991 // Illicit Collector Bond
];

export const RECKONING_NOTORIOUS_REAPER_WARLOCK = [
  2030998603, // Notorious Reaper Hood
  3734494146, // Notorious Reaper Gloves
  2966502282, // Notorious Reaper Robes
  2429433848, // Notorious Reaper Boots
  373632487 // Notorious Reaper Bond
];

export const RECKONING_NOTORIOUS_INVADER_WARLOCK = [
  2342017353, // Notorious Invader Hood
  239713976, // Notorious Invader Gloves
  1258016012, // Notorious Invader Robes
  1920643318, // Notorious Invader Boots
  1576110549 // Notorious Invader Bond
];

export const RECKONING_NOTORIOUS_COLLECTOR_WARLOCK = [
  359531059, // Notorious Collector Hood
  3271153034, // Notorious Collector Gloves
  4174424194, // Notorious Collector Robes
  77525088, // Notorious Collector Boots
  3526140223 // Notorious Collector Bond
];

export const RECKONING_NOTORIOUS_SENTRY_WARLOCK = [
  1823966647, // Notorious Sentry Hood
  458336262, // Notorious Sentry Gloves
  2765681918, // Notorious Sentry Robes
  2005998380, // Notorious Sentry Boots
  4051618675 // Notorious Sentry Bond
];



// WEBPACK FOOTER //
// ./src/setData/common/gambitPrimeStuff.js